const initialState = {
    isColourBlindEnabled: false,
};

export default (state = initialState, action) => {
    switch (action.type) {
        case "colourBlindEnabled":
            return {
                isColourBlindEnabled: !state.isColourBlindEnabled
            };
        default:
            return state;
    }
};